import { render } from "./AgentDemo.vue?vue&type=template&id=8a4bfb72&scoped=true"
import script from "./AgentDemo.vue?vue&type=script&lang=js"
export * from "./AgentDemo.vue?vue&type=script&lang=js"

import "./AgentDemo.vue?vue&type=style&index=0&id=8a4bfb72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a4bfb72"]])

export default __exports__